var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_1366_20213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1366_20213",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1366_20213",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1366_20213",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADoUlEQVR4nO2dO28TQRSFIyQESCAhQY8Q/AGQoOQh8Qjh/RCvJuDCnnMmVpSOLg0FKfgDlFACDbT0UAASBQUSIKUAxEMiFQmBJMhhgxK0ttf2rPdm9nzSyo09PrOf73hmZe8MDAghhBCiUGq12l6St0m+AvANwAzJSZKPAFRJbiw2YUkYGRnZDuAxyYU2x2eStaLzRg2A/SS/ZpDx7wBwt16vrys6e3QAOEJyuhMZy457ReePitHR0c0AvncpY6lSqkX3IyrQW4UsfqdUKpVNRfcjKkgO9ijlWtF9iA72IAXAg6Lzr0oAnATwluRr7/2BUFIAvCmmR6sYkhdIzi47ke+aPK8bKVP971FcMhYAfGjx/I6ktGpLZJMx55y72uZ1maUAeNaqLZHgnDv/vwyS8wDcQNgp8c0s7ZUalyKjURkkK520k6FS5p1zu/LrSQQAONdLZXRYKQ/D9yAiXKDKyFIpAL6Q3BYufQkqAwFkNJHSeNwXot0oQeBhqs3wNeW9PxGy3ahAzpWRdpU4j3ajADnJIHkxuczy0nu/O1ziiEF+MipJO0vtPg2XOlLQPxmN41W45BHivT/bLxkAfpEcCpc+MpDTbArA9ZTK+E3ySrj0kQHgePI7KckoGkiGHSAZdoBk2AGSUV4Z3vvL4dJHBiTDDiSHVBlGoGSUVsZs4/JLuPSRQcmwAyXDDpQMO1Ay7EDJsINz7phmU0ZwklFeGQDOhEsfGU4y7OAkww5OMuzgJMMOTjLsIBnGZKT802g+p6ntT01tJWN1oMowRJN/qc5rmJKMctPvyiB5Olz6yJAMQ0iGISTDEJJhCMkwhGQYQjIMIRklluGcOxUufWR4749KhhEkwxCSYQjJMIRkGEIyDCEZhpAMQzS5KbAWfUUgGYYAcDDlzsx53RZvRrfFa8H4+PiaZLdKybAAgD19/N3UyXDJI4XkjZQhZbCH9jRM9QKAJynbLHT1aVZl9Mjw8PB6AD+a7H3RkRTJCDfVbbVdTyYpkhEIkhNthLSVIhkBAfAig5CmUiQjIN77LSlT08xSJCMwAC51IGOFFMnIAQB3uhCyuE5JqazpXtYu4q+Q990ICbVmEcsguTOUDG2AFQCStQAyJhtXiUPkKT0A7nfx3dHYTeY5yVsADlWr1bWlP5GhAPApg4C5ZJ0y4b0/PDY2tiFYALGSxgbuTSS8T2ZfF6vV6ladtz7R+MQnUj4mw1etXq/v6Nf7CyGEEGKgK/4AGRDlWjxNJxQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.24f2695d9003d90f76f203a9b4e4af8a.svg";
export { ForwardRef as ReactComponent };